/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claimed_TitleInputs */

const en_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Congrats!
You’ve got`)
};

const ar_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تهانينا!
لقد حصلت على`)
};

const de_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belohnung freigeschaltet!`)
};

const es_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Felicidades!
Has conseguido`)
};

const fr_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Félicitations !
Vous avez obtenu`)
};

const it_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Congratulazioni!
Hai ottenuto`)
};

const ja_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おめでとう！
獲得しました`)
};

const ko_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`축하해요!
획득했어요`)
};

const pt_br_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parabéns!
Você recebeu`)
};

const ru_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поздравляем!
Вы получили`)
};

const th_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยินดีด้วย!
คุณได้รับ`)
};

const tr_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebrikler!
Kazandın`)
};

const zh_cn_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恭喜！
你获得了`)
};

const zh_tw_claimed_title = /** @type {(inputs: Claimed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恭喜！
你獲得了`)
};

/**
* | output |
* | --- |
* | "Congrats! You’ve got" |
*
* @param {Claimed_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const claimed_title = /** @type {((inputs?: Claimed_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claimed_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claimed_title(inputs)
	if (locale === "ar") return ar_claimed_title(inputs)
	if (locale === "de") return de_claimed_title(inputs)
	if (locale === "es") return es_claimed_title(inputs)
	if (locale === "fr") return fr_claimed_title(inputs)
	if (locale === "it") return it_claimed_title(inputs)
	if (locale === "ja") return ja_claimed_title(inputs)
	if (locale === "ko") return ko_claimed_title(inputs)
	if (locale === "pt_br") return pt_br_claimed_title(inputs)
	if (locale === "ru") return ru_claimed_title(inputs)
	if (locale === "th") return th_claimed_title(inputs)
	if (locale === "tr") return tr_claimed_title(inputs)
	if (locale === "zh_cn") return zh_cn_claimed_title(inputs)
	return zh_tw_claimed_title(inputs)
});